/**
 * NZ Batch Verify
 * Reads the public skeleton JSON (family/flavour/batch-number only) to
 * drive the three selects, and the protected report JSON — which only
 * exists in the page at all when the visitor is logged in — to render
 * results. If a batch is found in the public skeleton but has no entry
 * in the protected data, the visitor is logged out: show a login prompt
 * that returns them straight to this same report after logging in.
 */
(function () {
  if (window.__nzBatchVerifyInit) return;
  window.__nzBatchVerifyInit = true;

  function slugifyBatchNumber(raw) {
    return raw.trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function initApp(app) {
    var sectionId = app.getAttribute('data-section-id');
    var root = app.closest('.nz-bv') || document;
    var loggedIn = app.getAttribute('data-logged-in') === 'true';
    var loginUrl = app.getAttribute('data-login-url');
    var pageUrl = app.getAttribute('data-page-url');

    var publicEl = root.querySelector('script[data-nz-bv-payload="' + sectionId + '"]');
    var protectedEl = root.querySelector('script[data-nz-bv-protected="' + sectionId + '"]');

    var families = [];
    var reports = {};
    try {
      families = JSON.parse((publicEl && publicEl.textContent) || '[]');
    } catch (e) {
      console.error('NZ Batch Verify: could not parse public payload', e);
    }
    try {
      reports = JSON.parse((protectedEl && protectedEl.textContent) || '{}');
    } catch (e) {
      console.error('NZ Batch Verify: could not parse protected payload', e);
    }

    var $familyStep = app.querySelector('[data-nz-bv-step="family"]');
    var $family = app.querySelector('[data-nz-bv-field="family"]');
    var $flavourStep = app.querySelector('[data-nz-bv-step="flavour"]');
    var $flavour = app.querySelector('[data-nz-bv-field="flavour"]');
    var $batchStep = app.querySelector('[data-nz-bv-step="batch"]');
    var $batchSelect = app.querySelector('[data-nz-bv-field="batch_select"]');
    var $batchManual = app.querySelector('[data-nz-bv-field="batch_manual"]');
    var $submit = app.querySelector('[data-nz-bv-action="submit"]');
    var $error = app.querySelector('[data-nz-bv-error]');

    var $result = app.querySelector('[data-nz-bv-result]');
    var $login = app.querySelector('[data-nz-bv-login]');
    var $loginLink = app.querySelector('[data-nz-bv-login-link]');
    var $empty = app.querySelector('[data-nz-bv-empty]');
    var $loading = app.querySelector('[data-nz-bv-loading]');

    function resetSelect($select, placeholder) {
      $select.innerHTML = '<option value="">' + placeholder + '</option>';
    }

    function currentFamily() {
      var idx = $family.value;
      if (idx === '') return null;
      return families[parseInt(idx, 10)] || null;
    }

    function currentFlavour() {
      var fam = currentFamily();
      if (!fam) return null;
      var idx = $flavour.value;
      if (idx === '') return null;
      return fam.flavours[parseInt(idx, 10)] || null;
    }

    function onFamilyChange() {
      clearError();
      resetSelect($flavour, 'Select flavour');
      resetSelect($batchSelect, 'Select a batch');
      $batchManual.value = '';
      $batchStep.hidden = true;

      var fam = currentFamily();
      if (!fam) {
        $flavourStep.hidden = true;
        return;
      }

      (fam.flavours || []).forEach(function (flav, i) {
        var o = document.createElement('option');
        o.value = String(i);
        o.textContent = flav.flavorName;
        $flavour.appendChild(o);
      });
      $flavourStep.hidden = false;
    }

    function onFlavourChange() {
      resetSelect($batchSelect, 'Select a batch');
      var flav = currentFlavour();
      if (!flav) {
        $batchStep.hidden = true;
        return;
      }
      (flav.batches || []).forEach(function (b, i) {
        var o = document.createElement('option');
        o.value = String(i);
        o.textContent = i === 0 ? b.batchNumber + ' (most recent)' : b.batchNumber;
        $batchSelect.appendChild(o);
      });
      $batchStep.hidden = false;
    }

    function showError(msg) {
      $error.textContent = msg;
      $error.hidden = false;
    }

    function clearError() {
      $error.hidden = true;
      $error.textContent = '';
    }

    function findBatchNumberInSkeleton(raw) {
      var target = slugifyBatchNumber(raw);
      for (var f = 0; f < families.length; f++) {
        var flavours = families[f].flavours || [];
        for (var v = 0; v < flavours.length; v++) {
          var batches = flavours[v].batches || [];
          for (var b = 0; b < batches.length; b++) {
            if (slugifyBatchNumber(batches[b].batchNumber || '') === target) {
              return batches[b].batchNumber;
            }
          }
        }
      }
      return null;
    }

    function hideAllStates() {
      $loading.hidden = true;
      $result.hidden = true;
      $login.hidden = true;
      $empty.hidden = true;
    }

    function buildReturnUrl(batchNumber) {
      var url = new URL(pageUrl, window.location.origin);
      url.searchParams.set('family', $family.value);
      url.searchParams.set('flavour', $flavour.value);
      url.searchParams.set('batch', batchNumber);
      return url.toString();
    }

    function showLoginRequired(batchNumber) {
      hideAllStates();
      $login.hidden = false;
      var returnUrl = buildReturnUrl(batchNumber);
      $loginLink.href = loginUrl + '?return_to=' + encodeURIComponent(
        returnUrl.replace(window.location.origin, '')
      );
    }

    function showEmpty() {
      hideAllStates();
      $empty.hidden = false;
    }

    function renderResult(batch) {
      hideAllStates();
      $result.hidden = false;

      var banner = $result.querySelector('[data-nz-bv-banner]');
      banner.classList.toggle('is-pass', batch.status === 'Passed');
      banner.classList.toggle('is-fail', batch.status === 'Failed');
      banner.classList.toggle('is-pending', batch.status === 'Pending');

      $result.querySelector('[data-nz-bv-batch-number]').textContent = batch.batchNumber;
      $result.querySelector('[data-nz-bv-status]').textContent =
        batch.status === 'Passed'
          ? 'Batch passed all tests'
          : batch.status === 'Failed'
            ? 'Batch did not pass all tests'
            : 'Results pending';
      $result.querySelector('[data-nz-bv-test-date]').textContent = batch.testDate || '';
      $result.querySelector('[data-nz-bv-lab-name]').textContent = batch.labName || '';
      $result.querySelector('[data-nz-bv-lab-accreditation]').textContent = batch.labAccreditation
        ? '(' + batch.labAccreditation + ')'
        : '';

      var $tbody = $result.querySelector('[data-nz-bv-parameters]');
      $tbody.innerHTML = '';
      (batch.testParameters || []).forEach(function (p) {
        var tr = document.createElement('tr');
        var resultText = p.result + (p.unit ? ' ' + p.unit : '');
        tr.innerHTML =
          '<td></td><td></td><td></td><td class="' + (p.passed ? 'is-pass' : 'is-fail') + '"></td>';
        tr.children[0].textContent = p.name;
        tr.children[1].textContent = resultText;
        tr.children[2].textContent = p.limit;
        tr.children[3].textContent = p.passed ? '\u2713' : '\u2717';
        $tbody.appendChild(tr);
      });

      var $pdf = $result.querySelector('[data-nz-bv-pdf-link]');
      if (batch.pdfUrl) {
        $pdf.href = batch.pdfUrl;
        $pdf.hidden = false;
      } else {
        $pdf.hidden = true;
      }

      $result.querySelector('[data-nz-bv-auth-note]').textContent = batch.authNote || '';
      $result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function lookup(batchNumber) {
      var report = reports[batchNumber];
      if (report) {
        renderResult(report);
      } else if (!loggedIn) {
        showLoginRequired(batchNumber);
      } else {
        // Logged in but no report entry — treat as not found (e.g. unpublished mid-session).
        showEmpty();
      }
    }

    function onSubmit() {
      clearError();
      var manual = $batchManual.value.trim();
      var selectedIdx = $batchSelect.value;

      var batchNumber = null;
      if (selectedIdx !== '') {
        var flav = currentFlavour();
        var b = flav && flav.batches[parseInt(selectedIdx, 10)];
        batchNumber = b && b.batchNumber;
      } else if (manual) {
        batchNumber = findBatchNumberInSkeleton(manual);
      } else {
        showError('Select a batch from the list, or type the batch number printed on your pack.');
        return;
      }

      if (!batchNumber) {
        showEmpty();
        return;
      }
      lookup(batchNumber);
    }

    $family.addEventListener('change', onFamilyChange);
    $flavour.addEventListener('change', onFlavourChange);
    $submit.addEventListener('click', onSubmit);

    // Restore selection from ?family=&flavour=&batch= (set before sending
    // a logged-out visitor to /account/login) so they land straight back
    // on their report after logging in.
    var params = new URLSearchParams(window.location.search);
    var restoreFamily = params.get('family');
    var restoreFlavour = params.get('flavour');
    var restoreBatch = params.get('batch');

    // Also support ?family=<slug> from QR codes, matched against data-param.
    if (restoreFamily && !/^\d+$/.test(restoreFamily)) {
      var opt = Array.prototype.find.call($family.options, function (o) {
        return o.getAttribute('data-param') === restoreFamily;
      });
      if (opt) restoreFamily = opt.value;
    }

    if (restoreFamily !== null && restoreFamily !== '' && families[parseInt(restoreFamily, 10)]) {
      $family.value = restoreFamily;
      onFamilyChange();

      if (restoreFlavour !== null && restoreFlavour !== '') {
        $flavour.value = restoreFlavour;
        onFlavourChange();

        if (restoreBatch) {
          var opt2 = Array.prototype.find.call($batchSelect.options, function (o) {
            var flav = currentFlavour();
            var b = flav && flav.batches[parseInt(o.value, 10)];
            return b && b.batchNumber === restoreBatch;
          });
          if (opt2) {
            $batchSelect.value = opt2.value;
            lookup(restoreBatch);
          }
        }
      }
    }
  }

  document.querySelectorAll('[data-nz-bv-app]').forEach(initApp);
})();
